
export const bookingStatus = [
  { Id: "0", Name: "All" },
  { Id: "1", Name: "Success" },
  { Id: "2", Name: "Cancel" },
];

export const paymentGateways = [
  { Id: 1, Name: "Credit / Debit Card via OnePay" },
  { Id: 2, Name: "ATM Card via OnePay" },
  { Id: 3, Name: "Credit / Debit Card via PayPal" },
  { Id: 4, Name: "VietQR via OnePay" },
  { Id: 5, Name: "Payment Link via OnePay" },
  { Id: 6, Name: "VietQR Global via OnePay" },
];

export const paymentStatuses = [
  { Id: 1, Name: "Success" },
  { Id: 2, Name: "Cancel" },
  { Id: 4, Name: "Waiting Payment" },
];

export const invoiceStatus = [
  { Id: "-1", Name: "All" },
  { Id: "1", Name: "Publish" },
  { Id: "0", Name: "Unpublish" },
];

export const HOURS = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
];
export const MINUTES = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
];

export const STATUS = [
  { id: "0", name: "All" },
  { id: "1", name: "Active" },
  { id: "2", name: "InActive" },
];

export const EMPLOYMENT_TYPE = [
  { id: "0", name: "All" },
  { id: "1", name: "Full-time" },
  { id: "2", name: "Part-time" },
  { id: "3", name: "Freelancer" },
];

export const SUBMISSION_TYPE = [
  { id: "0", name: "All" },
  { id: "1", name: "Booking" },
  { id: "2", name: "Recruitment" },
]

export const MENU_TYPE = [
  { id: "Show", name: "Show" },
  { id: "Parent", name: "Parent" },
]

export const MENU_POSITION = [
  { id: "Top", name: "Top" },
  { id: "Bottom", name: "Bottom" },
]

export const HAS_WELCOME_DRINK = [
  { id: "0", name: "All" },
  { id: "1", name: "Yes" },
  { id: "2", name: "No" },
]

export const RATE_PLAN_TYPE = [
  { id: 1, name: "FAMILY PACKAGE" },
  { id: 2, name: "COMBO" },
  { id: 3, name: "EARLY BIRD" },
  { id: 4, name: "STANDARD" },
  { id: 5, name: "CAMPAIGN" },
  { id: 6, name: "PROMOTION" },
]
